// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "stock_order_item".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "stock_order_item" table (1:1 with a DB row, on the wire). */
export const stockOrderItemAtomSchema = z.object({
    id: z.string(),
    stockOrderId: z.string(),
    productId: z.string(),
    quantity: z.number(),
    receivedQuantity: z.number(),
    unitCostCents: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=stockOrderItem.js.map